import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";

const initialState = {
    enquiryPurpose: [],
    enquiryAction: [],
    enquiryStatus: [],
    enquiryIntrestedProduct: [],
};

let URL = endpoints.enquiryPurpose;
let URLForEnquiryAction = endpoints.enquiryAction;
let URLForEnquiryStatus = endpoints.enquiryStatus;
let URLForEnquiryIntrestedProduct = endpoints.enquiryIntrestedProduct;

const enquiryOperationsSlice = createSlice({
    name: "enquiryOperations",
    initialState,
    reducers: {
        enquiryPurposeSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                enquiryPurpose: row,
            };
        },

        enquiryActionSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                enquiryAction: row,
            };
        },

        enquiryStatusSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                enquiryStatus: row,
            };
        },

        enquiryIntrestedProductSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                enquiryIntrestedProduct: row,
            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const {
    enquiryPurposeSuccess,
    enquiryActionSuccess,
    enquiryStatusSuccess,
    enquiryIntrestedProductSuccess,
    resetState } = enquiryOperationsSlice.actions;

export default enquiryOperationsSlice.reducer;

export const getEnquiryPurpose = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((enquiryPurposeObject, index) => {
                    let enquiryPurposeData = {
                        index: index + 1,
                        id: enquiryPurposeObject.id === null ? "" : enquiryPurposeObject.id,
                        name: enquiryPurposeObject.name === null ? "" : enquiryPurposeObject.name,
                        isActive: enquiryPurposeObject.isActive === null ? "" : enquiryPurposeObject.isActive,
                    };
                    return enquiryPurposeData;
                });
                dispatch(enquiryPurposeSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return { response: [], success: false };
    }
};


export const getEnquiryAction = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URLForEnquiryAction,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((enquiryActionObj, index) => {
                    let enquiryActionData = {
                        index: index + 1,
                        id: enquiryActionObj.id === null ? "" : enquiryActionObj.id,
                        name: enquiryActionObj.name === null ? "" : enquiryActionObj.name,
                        isActive: enquiryActionObj.isActive === null ? "" : enquiryActionObj.isActive,
                    };
                    return enquiryActionData;
                });
                dispatch(enquiryActionSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return { response: [], success: false };
    }
};

export const getEnquiryStatus = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URLForEnquiryStatus,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((enquiryStatusObj, index) => {
                    let enquiryStatusData = {
                        index: index + 1,
                        id: enquiryStatusObj.id === null ? "" : enquiryStatusObj.id,
                        name: enquiryStatusObj.name === null ? "" : enquiryStatusObj.name,
                        isActive: enquiryStatusObj.isActive === null ? "" : enquiryStatusObj.isActive,
                    };
                    return enquiryStatusData;
                });
                dispatch(enquiryStatusSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return { response: [], success: false };
    }
};

export const getEnquiryIntrestedProduct = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URLForEnquiryIntrestedProduct + "/get-all",
        }).then(({ data, success }) => {
            if (success) {
                const row = data.data.map((enquiryIntrestedProductObj, index) => {
                    let enquiryIntrestedProductData = {
                        index: index + 1,
                        id: enquiryIntrestedProductObj.id === null ? "" : enquiryIntrestedProductObj.id,
                        enquiryId: enquiryIntrestedProductObj.enquiryId === null ? "" : enquiryIntrestedProductObj.enquiryId,
                        enquiryName: enquiryIntrestedProductObj.enquiryName === null ? "" : enquiryIntrestedProductObj.enquiryName,
                        productId: enquiryIntrestedProductObj.productId === null ? "" : enquiryIntrestedProductObj.productId,
                        productName: enquiryIntrestedProductObj.productName === null ? "" : enquiryIntrestedProductObj.productName,
                        isActive: enquiryIntrestedProductObj.isActive === null ? "" : enquiryIntrestedProductObj.isActive,
                    };
                    return enquiryIntrestedProductData;
                });
                dispatch(enquiryIntrestedProductSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return { response: [], success: false };
    }
};